module.exports = __webpack_public_path__ + "img/icon-restricted-area.d15863e5.svg";